/* ============================================================================
   Bold Grip Socks — live cart shipping state.
   Feeds the PDP "you're $X away" line (and any future consumers) by watching
   every cart mutation (fetch to /cart/add|change|update|clear) and re-reading
   /cart.js.

   Threshold is CURRENCY-AWARE and mirrors snippets/bm-freeship.liquid:
     CAD -> $50  free shipping        (5000¢)
     USD -> $70  free U.S. shipping   (7000¢)
     any other currency (UK, Singapore, Luxembourg, etc.) -> $70 in local currency, free shipping
   ========================================================================== */
(function () {
  if (window.__bmShipState) return; // no double-init
  window.__bmShipState = true;

  function thresholdFor(currency) {
    if (currency === 'CAD') return { amt: 5000, word: 'free shipping', cap: 'Free shipping' };
    if (currency === 'USD') return { amt: 7000, word: 'free U.S. shipping', cap: 'Free U.S. shipping' };
    return { amt: 7000, word: 'free shipping', cap: 'Free shipping' }; // international fallback $70 (local currency)
  }

  function fmt(cents) {
    var s = (cents / 100).toFixed(2);
    return '$' + s.replace(/\.00$/, '');
  }

  var lastKey = null;

  function render(total, currency) {
    var key = total + '|' + currency;
    if (key === lastKey) return;
    lastKey = key;

    var cfg = thresholdFor(currency);
    var lines = document.querySelectorAll('[data-bm-shipline]');
    var sr = document.querySelector('[data-bm-shipstatus]');

    if (!cfg || !total) {
      Array.prototype.forEach.call(lines, function (el) { el.hidden = true; });
      if (sr) sr.textContent = '';
      return;
    }

    Array.prototype.forEach.call(lines, function (el) {
      el.hidden = false;
      if (total >= cfg.amt) {
        el.classList.add('is-unlocked');
        el.innerHTML = '<span class="bm-shipline__check" aria-hidden="true">✓</span> ' + cfg.cap + ' unlocked';
      } else {
        el.classList.remove('is-unlocked');
        el.innerHTML = "You're <strong>" + fmt(cfg.amt - total) + '</strong> away from ' + cfg.word;
      }
    });
    if (sr) {
      sr.textContent = total >= cfg.amt
        ? cfg.cap + ' unlocked'
        : fmt(cfg.amt - total) + ' away from ' + cfg.word;
    }
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price || 0, c.currency); })
      .catch(function () {});
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = typeof a === 'string' ? a : ((a && a.url) || '');
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 200); }, function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
